import { render, staticRenderFns } from "./packing-plan-extra-form.vue?vue&type=template&id=b591801a&scoped=true&"
import script from "./packing-plan-extra-form.vue?vue&type=script&lang=ts&"
export * from "./packing-plan-extra-form.vue?vue&type=script&lang=ts&"
import style0 from "./packing-plan-extra-form.vue?vue&type=style&index=0&id=b591801a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b591801a",
  null
  
)

export default component.exports